export const GET_BUILDER_BY_EMAIL_ASYNC = 'GET_BUILDER_BY_EMAIL_ASYNC';
export const GET_BUILDER_BY_EMAIL_SUCCESS = 'GET_BUILDER_BY_EMAIL_SUCCESS';
export const GET_BUILDER_BY_ID_ASYNC = 'GET_BUILDER_BY_ID_ASYNC';
export const GET_BUILDER_BY_ID_SUCCESS = 'GET_BUILDER_BY_ID_SUCCESS';
export const RESET_INVITE_BUILDER = 'RESET_INVITE_BUILDER';
export const INVITE_BUILDER_ASYNC = 'INVITE_BUILDER_ASYNC';
export const INVITE_BUILDER_SUCCESS = 'INVITE_BUILDER_SUCCESS';
export const SEARCH_BUILDER_ASYNC = 'SEARCH_BUILDER_ASYNC';
export const SEARCH_BUILDER_SUCCESS = 'SEARCH_BUILDER_SUCCESS';
export const SEARCH_BUILDER_FOR_BULK_MAIL_ASYNC = 'SEARCH_BUILDER_FOR_BULK_MAIL_ASYNC';
export const SEARCH_BUILDER_FOR_BULK_MAIL_SUCCESS = 'SEARCH_BUILDER_FOR_BULK_MAIL_SUCCESS';
export const REMOVE_BUILDER_ASYNC = 'REMOVE_BUILDER_ASYNC';
export const RESEND_ACTIVE_EMAIL_BUILDER_ASYNC =
  'RESEND_ACTIVE_EMAIL_BUILDER_ASYNC';
export const SUSPENDED_BUILDER_ASYNC = 'SUSPENDED_BUILDER_ASYNC';
export const RESTORE_BUILDER_ASYNC = 'RESTORE_BUILDER_ASYNC';
export const RESET_BUILDER = 'RESET_BUILDER';
export const SETUP_BUILDER_EXISTED_USER_ASYNC =
  'SETUP_BUILDER_EXISTED_USER_ASYNC';
export const SETUP_BUILDER_NEW_USER_ASYNC = 'SETUP_BUILDER_NEW_USER_ASYNC';
export const SETUP_BUILDER_USER_SUCCESS = 'SETUP_BUILDER_USER_SUCCESS';
export const SETUP_BUILDER_USER_FAILED = 'SETUP_BUILDER_USER_FAILED';
export const CHECK_EMAIL_EXISTING_ASYNC = 'CHECK_EMAIL_EXISTING_ASYNC';
export const CHECK_EMAIL_EXISTING_SUCCESS = 'CHECK_EMAIL_EXISTING_SUCCESS';
export const CONFIG_SITE_ASYNC = 'CONFIG_SITE_ASYNC';
export const CONFIG_SITE_SUCCESS = 'CONFIG_SITE_SUCCESS';
export const CONFIG_SITE_FAILED = 'CONFIG_SITE_FAILED';
export const CHECK_ACCEPTED_TOS_ASYNC = 'CHECK_ACCEPTED_TOS_ASYNC';
export const CHECK_ACCEPTED_TOS_SUCCESS = 'CHECK_ACCEPTED_TOS_SUCCESS';
export const CHECK_ACCEPTED_TOS_FAILED = 'CHECK_ACCEPTED_TOS_FAILED';
export const ACCEPTED_TOS_ASYNC = 'ACCEPTED_TOS_ASYNC';
export const BUILDER_SETUP_DATA = 'BUILDER_SETUP_DATA';
export const BUILDER_SETUP_DATA_SUCCESS = 'BUILDER_SETUP_DATA_SUCCESS';
export const BUILDER_SETUP_DATA_FAILED = 'BUILDER_SETUP_DATA_FAILED';
export const CHECK_SETUP_TENANT_COMPLETED_ASYNC =
  'CHECK_SETUP_TENANT_COMPLETED_ASYNC';
export const CHECK_SETUP_TENANT_COMPLETED_SUCCESS =
  'CHECK_SETUP_TENANT_COMPLETED_SUCCESS';
export const GET_BUILDER_AVATAR_NAME_ASYNC = 'GET_BUILDER_AVATAR_NAME_ASYNC';
export const GET_BUILDER_AVATAR_NAME_SUCCESS =
  'GET_BUILDER_AVATAR_NAME_SUCCESS';
export const SET_SELECT_COLUMN = 'SET_SELECT_COLUMN';
export const CLOSE_MODAL_BUILDER_INFORMATION =
  'CLOSE_MODAL_BUILDER_INFORMATION';
export const VERIFY_TOKEN_SETUP_TENANT_ASYNC =
  'VERIFY_TOKEN_SETUP_TENANT_ASYNC';
export const SET_PAGE_SIZE_REFERENCE = 'SET_PAGE_SIZE_REFERENCE';
export const UPDATE_BUILDER_INFORMATION_ASYNC =
  'UPDATE_BUILDER_INFORMATION_ASYNC';
export const UPDATE_BUILDER_INFORMATION_SUCCESS =
  'UPDATE_BUILDER_INFORMATION_SUCCESS';



// WEBPACK FOOTER //
// ./src/Builders/constants.js